import React, { useEffect } from "react";

import Header from "../components/Header/Header";
import HeroSection from "../components/Solutions-InformationSecurity/Endpoint-security/HeroSection";
import Content from "../components/Solutions-InformationSecurity/Endpoint-security/Content";
// import ReactOutToUs from "../components/ReactOutToUs/ReactOutToUs";
import Footer from "../components/Footer/Footer";

const SolutionEndpoint = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <HeroSection />
      <Content />
      {/* <ReactOutToUs /> */}
      <Footer />
    </>
  );
};

export default SolutionEndpoint;
